const e = "Zum Bearbeiten „Enter“ drücken", t = {
  pressEnterToEdit: e
};
export {
  t as default,
  e as pressEnterToEdit
};
